import React, { useEffect, createElement } from 'react';
import { Home } from './pages/Home';
const META_PIXEL_ID = '2209161729849733';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Load the Meta Pixel base code once, with a safe script insertion that
    // does not assume an existing <script> tag exists in the document.
    if (!w.fbq) {
      const fbq: any = function () {
        // eslint-disable-next-line prefer-rest-params
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        // Safe fallback — prevents "Cannot read properties of undefined
        // (reading 'parentNode')" when no <script> node is present.
        ;
        (document.head || document.documentElement).appendChild(script);
      }
    }
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-0">
      <Home data-id="element-1" />
    </div>;
}